import { type Component, type ComponentProps, splitProps } from "solid-js";
import { cn } from "@boveda/shared";

const TextField: Component<ComponentProps<"input">> = (props) => {
  const [local, rest] = splitProps(props, ["class"]);
  return (
    <input
      class={cn(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        local.class,
      )}
      {...rest}
    />
  );
};

const Label: Component<ComponentProps<"label">> = (props) => {
  const [local, rest] = splitProps(props, ["class", "children"]);
  return (
    <label
      class={cn(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        local.class,
      )}
      {...rest}
    >
      {local.children}
    </label>
  );
};

export { TextField, Label };
